import request from '@/utils/request'

export function getUserInfo(data) {
  return request({
    url: '/api/sysUser/getUserInfo.json',
    method: 'post',
    data
  })
}